export default "__VITE_ASSET__CdO4gbxN__"